import { PersonShortDTO } from '@ternala/voltore-types';

export const getPersonName = (person?: PersonShortDTO): string => {
  return `${person?.firstName}${
    person?.middleName ? ' ' + person?.middleName : ''
  } ${person?.lastName} ${person?.nickName ? `(${person?.nickName})` : ''}`;
};
